import React from 'react';
import { Users, FileText, Settings as SettingsIcon, Megaphone, LayoutDashboard, Bell, Mail, ShieldAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const getMenuItems = (t) => [
  { id: 'dashboard', label: t('sidebar.menu.dashboard.label'), icon: LayoutDashboard, description: t('sidebar.menu.dashboard.description') },
  { id: 'members', label: t('sidebar.menu.members.label'), icon: Users, description: t('sidebar.menu.members.description') },
  { id: 'logs', label: t('sidebar.menu.logs.label'), icon: FileText, description: t('sidebar.menu.logs.description') },
  { id: 'advertisements', label: t('sidebar.menu.advertisements.label'), icon: Megaphone, description: t('sidebar.menu.advertisements.description') },
  { id: 'notifications', label: t('sidebar.menu.notifications.label'), icon: Bell, description: t('sidebar.menu.notifications.description') },
  { id: 'contactMessages', label: t('sidebar.menu.contactMessages.label'), icon: Mail, description: t('sidebar.menu.contactMessages.description') },
  { id: 'moderation', label: t('sidebar.menu.moderation.label'), icon: ShieldAlert, description: t('sidebar.menu.moderation.description') },
  { id: 'system', label: t('sidebar.menu.system.label'), icon: SettingsIcon, description: t('sidebar.menu.system.description') },
];

const AdminSidebar = ({ activeTab, setActiveTab }) => {
  const { t } = useTranslation('admin');
  const MENU_ITEMS = getMenuItems(t);
  return (
    <aside
      className="w-64 flex-shrink-0 border-r border-slate-200 dark:border-white/10 p-6 h-full overflow-y-auto bg-white dark:bg-[var(--color-bg-base)]"
      aria-label={t('sidebar.ariaLabel')}
    >
      <div className="mb-6">
        <h2 className="text-lg font-bold text-slate-900 dark:text-white">{t('sidebar.title')}</h2>
        <p className="text-xs text-slate-500 dark:text-slate-400 mt-0.5">
          {t('sidebar.subtitle')}
        </p>
      </div>
      <nav className="flex flex-col gap-0.5">
        {MENU_ITEMS.map((item) => {
          const Icon = item.icon;
          const isActive = activeTab === item.id;
          return (
            <button
              key={item.id}
              type="button"
              onClick={() => setActiveTab(item.id)}
              className={`
                flex items-center gap-3 w-full text-left px-3 py-2.5 rounded-md text-sm transition-colors
                ${isActive
                  ? 'bg-blue-50 text-blue-700 font-medium dark:bg-blue-900/20 dark:text-blue-400'
                  : 'text-slate-600 dark:text-slate-400 hover:bg-slate-50 dark:hover:bg-[var(--color-bg-elevated)]'
                }
              `}
            >
              <Icon className="w-5 h-5 flex-shrink-0" strokeWidth={isActive ? 2.2 : 2} />
              <span className="truncate">{item.label}</span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
};

export default AdminSidebar;
